"use client";
import React, { useEffect, useState } from "react";
import { ButtonComponent, ModalComponent, SliderComponent } from "@/components";
import { Stack, Typography } from "@mui/material";
import { CurrencyConverter, WEB_COLORS, WEB_EVENTS } from "@/lib/constants";
import { useGetCustomerQuery, useInitiatePaymentMutation } from "@/lib/redux";
import { usePaytmJSCheckout } from "@/lib/hooks/usepaytmjscheckout";
import { sendEventAnalytics } from "@/lib/hooks/eventAnalytics";

const AdvanceEmiModal = ({
  open,
  handleModal,
  advanceEmi,
  emiAmount,
  appId,
}) => {
  const [advanceEmiCount, setAdvaceEmiCount] = useState(1);
  const url = `${process.env.NEXT_PUBLIC_PAYTM_HOST}/merchantpgpui/checkoutjs/merchants/${process.env.NEXT_PUBLIC_PAYTM_RETAIL_MID}.js`;
  const [generatePaymentToken, { data: paymentDetails }] =
    useInitiatePaymentMutation();
  const { data: customerData } = useGetCustomerQuery();
  const [scriptLoaded, handleScript] = usePaytmJSCheckout(url, paymentDetails);
  const InitiatePayment = () => {
    sendEventAnalytics({
      eventName: WEB_EVENTS.PAY_ADVANCE_EMI,
      appId: appId,
      ...customerData?.data,
    });
    let body = {
      source: "DIGI2WEB",
      txnAmount: (advanceEmiCount * emiAmount)?.toString(),
      custId: appId,
      isRetail: "true",
      transactionTowards: "OTHER",
    };
    if (
      !paymentDetails?.token ||
      paymentDetails?.loanAmount !== (advanceEmiCount * emiAmount)?.toString()
    ) {
      generatePaymentToken(body);
    } else {
      handleScript({ type: "load" }, body?.txnAmount?.toString());
    }
  };

  useEffect(() => {
    if (paymentDetails?.token) {
      sendEventAnalytics({
        eventName: WEB_EVENTS.PAYTM_REDIRECTION_TRANSACTION_TOKEN,
        appId,
        ...customerData?.data,
      });
      handleScript({ type: "load" }, paymentDetails?.loanAmount);
    }
  }, [paymentDetails?.token]);

  const handleChange = (_, newValue) => {
    setAdvaceEmiCount(newValue);
  };

  const marks = Array.from(
    { length: (advanceEmi - 1) / 1 + 1 + 1 },
    (_, index) => ({
      value: index * 1,
      label: `${index * 1}`,
    }),
  );
  return (
    <ModalComponent
      fullWidth
      maxWidth="lg"
      open={open}
      handleModal={handleModal}
      title={"Pay Advance EMI"}
    >
      <Stack gap={2}>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Typography variant="h6">EMI</Typography>
          <Typography variant="h6">
            {CurrencyConverter(emiAmount)} X {advanceEmiCount} ={" "}
            {CurrencyConverter(advanceEmiCount * emiAmount)}
          </Typography>
        </Stack>
        <SliderComponent
          marks={marks}
          valueLabelDisplay="auto"
          formatRequired={false}
          max={advanceEmi}
          min={1}
          value={advanceEmiCount}
          onChange={handleChange}
          step={1}
        />
      </Stack>
      <Typography color={WEB_COLORS.textFadeColor}>
        Slide to Select Number of EMIs you want to pay in advance
      </Typography>
      <Stack mt={4} mb={2}>
        <ButtonComponent disabled={!scriptLoaded} onClick={InitiatePayment}>
          Proceed to Pay {CurrencyConverter(advanceEmiCount * emiAmount)}
        </ButtonComponent>
      </Stack>
    </ModalComponent>
  );
};

export default AdvanceEmiModal;
